import { render, staticRenderFns } from "./menuDespachante.vue?vue&type=template&id=c6783444&scoped=true&"
import script from "./menuDespachante.vue?vue&type=script&lang=js&"
export * from "./menuDespachante.vue?vue&type=script&lang=js&"
import style0 from "./menuDespachante.vue?vue&type=style&index=0&id=c6783444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6783444",
  null
  
)

export default component.exports